import React from "react";
import { useAppSelector } from "../../../store/hooks/StoreHooks";

interface SwitchButtonProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string;
    labelPosition?: "right" | "bottom";
    disabled?: boolean;
}

const SwitchButton: React.FC<SwitchButtonProps> = ({
    checked,
    onChange,
    label,
    labelPosition = "right",
}) => {

    const { customerEnabled, customerCreated } = useAppSelector((state) => state.auth);
    const { projectReadOnly } = useAppSelector((state) => state.projectHeader);

    return (
        <div
            className={`flex items-center ${labelPosition === "bottom" ? "flex-col" : "flex-row"
                }`}
        >
            <label className="relative inline-block w-[36px] h-[20px]">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => onChange(!checked)}
                    className={`opacity-0 w-0 h-0 absolute`}
                    disabled={(customerEnabled && !customerCreated) || projectReadOnly}
                    style={{ cursor: ((customerEnabled && !customerCreated) || projectReadOnly) ? "not-allowed" : "pointer" }}
                />
                <span
                    className={`absolute  top-0 left-0 right-0 bottom-0 rounded-full transition-colors duration-400 ${checked ? "bg-primary-600" : "bg-darkcolor-600"
                        } ${((customerEnabled && !customerCreated) || projectReadOnly) ? "cursor-not-allowed" : "cursor-pointer"}`}
                >
                    <span
                        className={`absolute bg-neutral-25 w-[16px] h-[16px] left-[4px] bottom-[2px] rounded-full transition-transform duration-400 ${checked ? "translate-x-[12px]" : "translate-x-0"
                            }`}
                    />
                </span>
            </label>
            <label className="text-neutral-25 text-[14px] font-semibold mx-[8px]">
                {label}
            </label>
        </div>
    );
};

export default SwitchButton;
